export const getCellStyle = (size?: string | number) => {
  if (!size) return { flexBasis: "50px", flexGrow: 1 }
  if (typeof size === "number") return { flexBasis: "50px", flexGrow: size }
  return { flexBasis: size, flexShring: 0 }
}